import * as Sentry from '@sentry/browser';
import { initLoc as initLocalization } from '../../../../packages/src/localization/index.js';

export { t } from '../../../../packages/src/localization/index.js';

export function saveLocParams({ selectedLang, orgId, eventCode } = {}) {
  sessionStorage.setItem('locParams', JSON.stringify({ orgId, eventCode, selectedLang }));
}

function getLocParams() {
  return JSON.parse(sessionStorage.getItem('locParams') || '{}');
}

export async function initLoc({ selectedLang, orgId, eventCode } = getLocParams()) {
  if (!orgId || !eventCode || !selectedLang) {
    const error = new Error(
      'Organisation ID, Event Code, and Selected Language are required for localisation initialization.'
    );
    Sentry.captureException(error);
  }

  await initLocalization({
    initialLanguage: selectedLang,
    orgId,
    eventCode,
    projectName: 'universal-kiosk',
    languageSettings: {
      availableLanguages: [selectedLang],
      defaultLanguage: selectedLang,
    },
  });
}

export function setTextToElement(cssPath, text) {
  const element = document.querySelector(cssPath);
  if (element) {
    element.textContent = text;
  } else {
    const error = new Error(`Element not found for CSS path: ${cssPath}`);
    console.error(error);
    Sentry.captureException(error);
  }
}
